export type ActionErrorAi = {
    code: string;
    message: string;
};

const isActionErrorAi = (obj: unknown): obj is ActionErrorAi => {
    return (
        typeof obj === 'object' &&
        obj !== null &&
        'code' in obj &&
        'message' in obj &&
        typeof (obj as ActionErrorAi).code === 'string' &&
        typeof (obj as ActionErrorAi).message === 'string'
    );
};

export default isActionErrorAi;
